import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getPAEAA010, getPAEAA010Apply } from '../../../../services/Api';
import { formatDate } from '../../../../utils';
const PAEAA060 = ({ closePopup, popupData }) => {
    const navigator = useNavigate();
    const [resumesLatest, setResumesLatest] = useState([]);
    const [recruitingCV, setRecruitingCV] = useState([]);
    const [status, setStatus] = useState(3);
    const [selectedResumeSeq, setSelectedResumeSeq] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await getPAEAA010();
                setResumesLatest(data.resumesLatest);
                setRecruitingCV(data.recruitingCV);

                if (data?.resumesLatest?.length > 0) {
                    setStatus(1);
                    setSelectedResumeSeq(data.resumesLatest[0].resSeq);
                }
                if (data.resumesLatest === null && data?.recruitingCV?.length > 0) {
                    setStatus(2);
                }
                if (data.resumesLatest === null && data.recruitingCV === null) {
                    setStatus(3);
                }
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, []);

    const handleActiveConditions = () => {
        // setActiveConditions(!activeConditions);
        navigator('/paiab020');
    };

    const handleSelectCv = (e) => {
        setSelectedResumeSeq(Number(e.target.value));
    };

    const handleApply = async () => {
        if (!selectedResumeSeq) {
            window.alert('이력서를 선택해 주세요.');
            return;
        }
        if (window.confirm('해당 이력서로 지원하시겠습니까?')) {
            try {
                const response = await getPAEAA010Apply({
                    params: {
                        recruitSeq: popupData?.recruitSeq,
                        resumeSeq: selectedResumeSeq,
                    },
                });

                if (response.data === 'success') {
                    window.alert('선택하신 이력서로 입사지원이 완료되었습니다. 감사합니다.');
                } else if (response.data === 'applied') {
                    window.alert('이미 지원한 공고입니다.');
                }
                closePopup();
            } catch (error) {
                console.error('Error:', error);
            }
        }
    };

    return (
        <div id="footer">
            <div className="popup active" htmlFor="support-1">
                <div className="popup-support">
                    <button className="popup-close sizeUp" onClick={closePopup} />
                    <div className="popup-header">
                        <p className="popup-header-number-room">{popupData?.companyName}</p>
                        <div className="popup-header-title">{popupData?.title}</div>
                        <ul className="wrap-link">
                            <li>
                                <span>{popupData?.recruitCareer}</span>
                            </li>
                            <li>
                                <span>{popupData?.recruitForm}</span>
                            </li>
                            <li>
                                <span>{popupData?.recruitLicense}</span>
                            </li>
                        </ul>
                    </div>
                    <div className="popup-content popup-content--gray">
                        <div className="popup-top">
                            <div className="popup-content-header">
                                <div className="header-item-top">
                                    <span>최근 지원한 이력서</span>
                                </div>
                                {/* tạm thời ẩn theo yc anh Tuấn Anh */}
                                {/* {status !== 3 && (
                                    <button className="saved-conditions active" data-type="slideToggle">
                                        <span>이력서 변경</span>
                                        <i className="icon icon-down" />
                                    </button>
                                )} */}
                            </div>
                            {status === 1 &&
                                resumesLatest.map((resume, index) => (
                                    <div className="box-support" key={index}>
                                        <div className="box-support-date date-box">{formatDate(resume.applyDate)}</div>
                                        <div className="box-support-title">{resume.resumeLvl === 'Y' ? '(공개)' : '(비공개)'} {resume.resTitle}</div>
                                        <ul className="box-support-list">
                                            <li>
                                                <span className="box-support-list-title">이메일</span>
                                                <span className="box-support-list-content">{resume.email}</span>
                                            </li>
                                            <li>
                                                <span className="box-support-list-title">휴대폰</span>
                                                <span className="box-support-list-content">{resume.mobileNo}</span>
                                            </li>
                                        </ul>
                                        <div className="box-support-edit">
                                            <Link to={`/paiab010-${resumesLatest[0]?.resSeq}`}>수정</Link>
                                        </div>
                                    </div>
                                ))}
                            {status === 2 && (
                                <div className="box-support box-support--empty">
                                    <div className="box-support-title">
                                        지원한 이력서가 없습니다.
                                        <br />
                                        아래 이력서 공개 목록에서 이력서를 선택해 주세요.
                                    </div>
                                </div>
                            )}
                            {status === 3 && (
                                <div className="box-support box-support--empty">
                                    <div className="box-support-title">지원한 이력서가 없습니다.</div>
                                </div>
                            )}
                        </div>
                        <div className="popup-bottom">
                            <div className="popup-content-header popup-content-header-after-box">
                                <div className="header-item-top">
                                    <span>이력서 목록 <br /><span style={{ color: 'red', fontSize: '15px' }}>* 비공개 이력서도 지원한 치과에서는 열람할 수 있습니다.</span></span>

                                </div>
                                <button className="right" onClick={handleActiveConditions}>
                                    <span>이력서 관리</span>
                                    <i className="icon icon-down right" />
                                </button>
                            </div>
                            <div
                                className={`group-radio group-radio-1`}
                            // className={`group-radio group-radio-1 ${activeConditions ? 'active' : ''}`}
                            // style={{
                            //     maxHeight: activeConditions ? '500px' : '0',
                            //     overflow: 'hidden',
                            // }}
                            >
                                {status !== 3 ? (
                                    recruitingCV.map((item, index) => (
                                        <label className={index === 0 ? 'active' : ''} key={item.seq}>
                                            <input
                                                type="radio"
                                                name="recruitingCV"
                                                value={item.seq}
                                                checked={item.seq === selectedResumeSeq}
                                                onChange={handleSelectCv}
                                            />
                                            <div className="radio-content">
                                                <div className="radio-content-date date-box">
                                                    {formatDate(item.addDate)}
                                                </div>
                                                <span className="radio-content-title">{item.resumeLvl === 'Y' ? '(공개)' : '(비공개)'} {item.title}</span>
                                            </div>
                                        </label>
                                    ))
                                ) : (
                                    <div className="box-support box-support--empty">
                                        <div className="box-support-title">
                                            공개된 이력서가 없습니다.
                                            <br />
                                            이력서 관리 목록에서 이력서를 확인해 주세요.
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="popup-footer">
                        {status !== 3 ? (
                            <button className="popup-footer-btn" onClick={handleApply}>
                                지원하기
                            </button>
                        ) : (
                            <Link to="/paiab010" className="popup-footer-btn">
                                새 이력서 등록
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PAEAA060;
